export default {
  beforeMount(el, binding) {
    el.__ClickOutSideCB__ = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event, 'Hola')
      }
    }

    document.body.addEventListener('click', el.__ClickOutSideCB__)
  },

  unmounted(el) {
    document.body.removeEventListener('click', el.__ClickOutSideCB__)
  }
}
